import PasswordGate from './PasswordGate';
import SiteScout from './SiteScout';

export default function App() {
  return (
    <PasswordGate>
      <SiteScout />
    </PasswordGate>
  );
}
